/**
 * Copyright 2023 Design Barn Inc.
 */

import { DotLottieStateMachineCommon, type DotLottieStateMachineCommonOptions } from '../common';

export class LottieStateMachine extends DotLottieStateMachineCommon {
  public constructor(options: DotLottieStateMachineCommonOptions) {
    super(options);
  }
}
